<template lang="pug">
  v-snackbar(
    top,
    multi-line,
    color="error",
    v-model="show")
    slot(name="message")
    v-btn(flat dark @click="$emit('close-snackbar')") Закрыть
</template>

<script>
export default {
  name: 'Snackbar',
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Common/Snackbar/Snackbar.vue